import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCrown, faCheck } from '@fortawesome/free-solid-svg-icons';
import '../styles/WaitlistSuccessModal.css';

const WaitlistSuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="waitlist-success-modal-overlay">
      <div className="waitlist-success-modal">
        {/* Success icon and crown */}
        <div className="waitlist-success-icon">
          <div className="success-check">
            <FontAwesomeIcon icon={faCheck} />
          </div>
          <div className="premium-crown">
            <FontAwesomeIcon icon={faCrown} />
          </div>
        </div>

        {/* Modal content */}
        <div className="waitlist-success-content">
          <h2 className="waitlist-success-title">
            🎉 Congratulations!
          </h2>
          <p className="waitlist-success-message">
            You've unlocked <strong>1 year of Yesod Premium</strong> - free when it launches.
          </p>
          <p className="waitlist-success-subtitle">
            Until then, enjoy full free access to Yesod and start building the best experience for your community today.
          </p>
        </div>

        {/* CTA button */}
        <button className="waitlist-success-cta" onClick={onClose}>
          Continue to Dashboard
        </button>
      </div>
    </div>
  );
};

export default WaitlistSuccessModal;
